import { render, staticRenderFns } from "./table-body.vue?vue&type=template&id=993898a8&scoped=true"
import script from "./table-body.vue?vue&type=script&lang=js"
export * from "./table-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993898a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('993898a8')) {
      api.createRecord('993898a8', component.options)
    } else {
      api.reload('993898a8', component.options)
    }
    module.hot.accept("./table-body.vue?vue&type=template&id=993898a8&scoped=true", function () {
      api.rerender('993898a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/table/table-body.vue"
export default component.exports